module.exports = __webpack_public_path__ + "img/tuto1.6425a3fb.png";